<hlm-dialog [state]="state()" (closed)="state.set('closed')" autoFocus="textarea">
  <hlm-dialog-content
    *brnDialogContent="let ctx"
    class="min-w-[min(32rem,calc(100vw-2rem))] sm:max-w-lg"
    (paste)="onPaste($event)"
    (dragover)="$event.preventDefault()"
    (drop)="onDrop($event)"
  >
    <hlm-dialog-header>
      <h3 hlmDialogTitle>{{ copy().title }}</h3>
      <p hlmDialogDescription>{{ copy().description }}</p>
    </hlm-dialog-header>

    <!-- One field: text, attached images and the paperclip share the same border. -->
    <div class="min-w-0" [class]="fieldChrome">
      <textarea
        rows="5"
        class="block w-full resize-none bg-transparent px-3 pt-2.5 pb-1 text-sm leading-normal outline-none"
        [class]="fieldText"
        aria-label="Nachricht"
        [placeholder]="copy().placeholder"
        [maxLength]="maxMessageLength"
        [value]="message()"
        (input)="message.set($any($event.target).value)"
        (keydown.meta.enter)="send()"
        (keydown.control.enter)="send()"
      ></textarea>

      <div class="flex flex-wrap items-end gap-2 px-2 pb-2">
        @for (shot of screenshots(); track shot.url; let i = $index) {
          <div class="relative">
            <img [src]="shot.url" [alt]="'Screenshot ' + (i + 1)" class="h-12 w-16 rounded-md border object-cover" />
            <button
              type="button"
              class="absolute -right-1.5 -top-1.5 flex size-4 items-center justify-center rounded-full border bg-background text-muted-foreground hover:text-foreground"
              [attr.aria-label]="'Screenshot ' + (i + 1) + ' entfernen'"
              (click)="removeScreenshot(i)"
            >
              <ng-icon name="lucideX" class="size-2.5" />
            </button>
          </div>
        }
        @if (screenshots().length < maxScreenshots) {
          <button
            type="button"
            class="ml-auto flex size-7 items-center justify-center rounded-md text-muted-foreground/70 transition-colors hover:bg-muted hover:text-foreground"
            aria-label="Bild anhängen"
            title="Bild anhängen"
            (click)="fileInput.click()"
          >
            <ng-icon name="lucidePaperclip" class="size-4" />
          </button>
          <input #fileInput type="file" multiple class="hidden" [accept]="screenshotTypes" (change)="onFilesSelected(fileInput)" />
        }
      </div>
    </div>

    <hlm-dialog-footer>
      <button hlmBtn type="button" [disabled]="!canSend()" (click)="send()">
        @if (sending()) {
          <ng-icon name="lucideLoader" class="mr-2 size-4 animate-spin" />
        } @else {
          <ng-icon name="lucideSend" class="mr-2 size-4" />
        }
        Senden
      </button>
    </hlm-dialog-footer>
  </hlm-dialog-content>
</hlm-dialog>
